export const translations = {
  zh: {
    // 通用
    loading: "加载中...",
    submit: "提交",
    cancel: "取消",
    confirm: "确认",
    edit: "编辑",
    delete: "删除",
    save: "保存",
    logout: "退出登录",
    welcome: "欢迎",
    
    // 语言选择
    language: "语言",
    selectLanguage: "选择语言",
    chinese: "中文",
    japanese: "日本語",
    english: "English",
    
    // 登录/注册
    login: "登录",
    register: "注册",
    email: "邮箱地址",
    password: "密码",
    confirmPassword: "确认密码",
    loginTitle: "湘南国际株式会社\n旅行社专用预约系统",
    loginSubtitle: "欢迎回来，请登录您的账号",
    loginPanelTitle: "账户登录",
    loginPanelSubtitle: "Sign In",
    loginSystem: "登录系统",
    authPlatformLine: "Professional Transportation Booking Platform",
    authTrustedTagline: "服务全球旅行社合作伙伴",
    authLogoCaption: "旅行社专用预约平台",
    registerTitle: "湘南国际株式会社\n旅行社专用预约系统",
    registerSubtitle: "创建您的账号",
    authFeatureSecure: "专用预约流程保护",
    authFeatureLanguages: "中文 / 日本語 / English",
    authFeatureOperations: "旅行社与车队运营管理",
    authFeatureQualityTitle: "高品质服务与整洁车辆",
    authFeatureQualityDesc: "专业司机团队，车辆定期清洁维护，提供舒适安心的出行体验",
    authFeatureLanguagesTitle: "多语言支持",
    authFeatureLanguagesDesc: "中文・English・日本語，无障碍沟通，快速响应客户需求",
    authFeatureBookingTitle: "便捷的预约管理系统",
    authFeatureBookingDesc: "行程开始前48小时内可随时在线修改预约信息",
    systemTitle: "湘南国际株式会社旅行社专用预约系统",
    noAccount: "还没有账号？",
    hasAccount: "已有账号？",
    registerNow: "立即注册",
    loginNow: "立即登录",
    loginFailed: "登录失败，请检查邮箱和密码",
    registerSuccess: "注册成功！",
    registerSuccessMsg: "您的账号已提交，请等待管理员审核。审核通过后即可登录。",
    redirecting: "正在跳转到登录页面...",
    
    // 用户信息
    customerCode: "客户编码",
    customerName: "客户名称",
    companyName: "公司/姓名",
    phone: "联系电话",
    phoneOptional: "联系电话（可选）",
    name: "姓名",
    
    // 车型
    vehicleType: "车型",
    alpha: "阿尔法",
    hiace: "海狮",
    luxuryHiace: "豪华海狮",
    coaster: "考斯特",
    bus: "巴士",
    hiace14Seats: "14座海狮",
    
    // 订单相关
    myOrders: "我的订单",
    createOrder: "创建新订单",
    orderDetails: "订单详情",
    orderSearchPlaceholder: "搜索订单所有信息",
    supplierCustomerCodeFilterPlaceholder: "根据客户编号筛选",
    supplierCustomerNameFilterPlaceholder: "根据客户名字筛选",
    orderGroupAll: "全部订单",
    orderGroupCompleted: "已完成",
    orderGroupOngoing: "进行中",
    orderGroupNotStarted: "未开始",
    orderGroupToday: "今天",
    orderGroupTomorrow: "明天",
    orderNumber: "订单号",
    supplierVehicleFilterAll: "全部车型",
    supplierExportVisibleOrders: "导出当前订单",
    supplierExportNoOrders: "当前没有可导出的订单",
    supplierActionConfirm: "确认",
    supplierActionModify: "修改",
    supplierActionCancel: "取消",
    supplierActionConfirmed: "已确认",
    supplierActionUnavailable: "当前不可操作",
    supplierOpenChat: "打开聊天",
    supplierChatUnavailable: "聊天未开启",
    supplierImportantException: "重要异常",
    supplierNotesAndContact: "备注 / 特殊要求 / 联系信息",
    supplierMissingField: "缺少字段",
    supplierNoMatchingOrders: "没有符合条件的订单",
    supplierSelectAll: "全选",
    supplierBulkCancel: "批量取消",
    supplierShowingOrders: "显示订单",
    supplierSortNewest: "开始日期：从后往前",
    supplierSortOldest: "开始日期：从前往后",
    supplierSortServiceDateDesc: "开始日期：从后往前",
    supplierSortServiceDateAsc: "开始日期：从前往后",
    supplierServiceFilterAll: "全部服务",
    supplierServiceTransfer: "接送机",
    supplierServiceCharter: "包车",
    supplierHideCompleted: "隐藏已完成",
    supplierHideCancelled: "隐藏已取消",
    supplierCopyOrder: "复制订单",
    supplierReturnOrder: "生成返程",
    supplierTripSummary: "行程摘要",
    supplierPriceReference: "价格仅供参考",
    supplierPaymentPaid: "已付款",
    supplierExportFilename: "供应商订单",
    orderType: "订单类型",
    presetRoute: "预设路线",
    customRoute: "自定义路线",
    presetRouteDesc: "固定价格，快速下单",
    customRouteDesc: "等待报价",
    
    // 新订单流程
    departureLocation: "出发地",
    selectDeparture: "选择出发地",
    tokyo: "东京",
    haneda: "羽田",
    narita: "成田",
    yokohama: "横滨",
    kanazawa: "金泽",
    other: "其他",
    
    serviceType: "服务类型",
    selectServiceType: "选择服务类型",
    transfer: "接送/接机/接火车站",
    charter: "包车",
    
    charterDuration: "包车时间",
    selectCharterDuration: "选择包车时间",
    hours4: "4小时",
    hours6: "6小时",
    hours8: "8小时",
    hours10: "10小时",
    hours12: "12小时",
    
    // 额外服务
    extraServices: "额外服务",
    selectExtraServices: "选择需要的额外服务",
    airportSign: "机场举牌",
    tokyoStationSign: "东京站举牌",
    odawaraStationSign: "小田原车站举牌",
    hotelSign: "酒店举牌",
    shinkansenTicket: "取新干线票",
    otherService: "其他额外服务",
    otherServiceDesc: "请填写您的其他需求",
    otherServicePlaceholder: "请描述您需要的其他服务...",
    needsApproval: "需要管理员审核",
    
    // 订单信息
    pickupLocation: "上车地点",
    destination: "目的地",
    departureDate: "出发日期",
    pickupTime: "出发时间",
    passengerCount: "乘客人数",
    luggageCount: "行李数量",
    tripDetails: "具体行程",
    tripDetailsOptional: "具体行程（可选）",
    tripDetailsPlaceholder: "如有特殊要求或详细行程安排，请在此说明...",
    
    // 价格
    price: "价格",
    totalPrice: "订单合计",
    waitingForQuote: "等待报价",
    vehiclePrice: "车辆价格",
    basePrice: "基础价格",
    extraServicePrice: "额外服务费用",
    pendingQuote: "等待报价",
    
    // 订单状态
    status: "状态",
    pending: "待确认",
    pendingConfirmation: "确认中",
    pendingQuoteStatus: "等待报价",
    quoted: "已报价",
    confirmed: "已确认",
    completed: "已完成",
    cancelled: "已取消",
    
    // 操作
    acceptQuote: "接受报价",
    modifyOrder: "修改订单",
    cancelOrder: "取消订单",
    canModify: "可以修改订单",
    cannotModify: "出发时间在48小时内，需要联系管理员修改",
    confirmCancel: "确定要取消此订单吗？此操作不可撤销。",
    cancelSuccess: "订单已成功取消",
    updateSuccess: "订单修改成功",
    editRoute: "编辑路线",
    updateRoute: "更新路线",
    routeUpdateSuccess: "路线更新成功",
    
    // 管理员
    adminDashboard: "管理员后台",
    userManagement: "用户管理",
    routeManagement: "路线管理",
    orderManagement: "订单管理",
    billingExport: "账单导出",
    pendingUsers: "待审核用户",
    allUsers: "所有用户",
    approve: "批准",
    reject: "拒绝",
    approved: "已批准",
    rejected: "已拒绝",
    
    // My Page
    myPage: "我的页面",
    manageYourAccount: "管理您的账户信息",
    accountInfo: "账户信息",
    editProfile: "编辑资料",
    changePassword: "修改密码",
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmNewPassword: "确认新密码",
    saveChanges: "保存修改",
    saving: "保存中...",
    profileUpdateSuccess: "资料更新成功",
    passwordChangeSuccess: "密码修改成功",
    passwordMismatch: "两次输入的密码不一致",
    passwordTooShort: "密码长度至少为6个字符",
    emailCannotChange: "邮箱地址不可修改",
    passwordMinLength: "至少6个字符",
    
    // 路线管理
    addRoute: "添加路线",
    routeName: "路线名称",
    routeType: "路线类型",
    routeDescription: "路线描述",
    priceAlpha: "阿尔法价格",
    priceHiace: "海狮价格",
    priceLuxuryHiace: "豪华海狮价格",
    
    // 提示信息
    createOrderSuccess: "订单创建成功！",
    updateOrderSuccess: "订单更新成功！",
    operationFailed: "操作失败",
    noOrders: "暂无订单",
    createFirstOrder: "创建第一个订单",
    fillOrderInfo: "请填写订单信息",
    selectRoute: "选择路线",
    selectRoutePlaceholder: "-- 请选择路线 --",
    noRoutesAvailable: "暂无可用路线",
    deleteOrder: "删除订单",
    confirmDelete: "确定要删除此订单吗？此操作不可撤销。",
    deleteSuccess: "删除成功",
    orderNotStarted: "未开始",
    orderInProgress: "进行中",
    orderCompleted: "已完成",
  },
  
  ja: {
    // 共通
    loading: "読み込み中...",
    submit: "送信",
    cancel: "キャンセル",
    confirm: "確認",
    edit: "編集",
    delete: "削除",
    save: "保存",
    logout: "ログアウト",
    welcome: "ようこそ",
    
    // 言語選択
    language: "言語",
    selectLanguage: "言語を選択",
    chinese: "中文",
    japanese: "日本語",
    english: "English",
    
    // ログイン/登録
    login: "ログイン",
    register: "登録",
    email: "メールアドレス",
    password: "パスワード",
    confirmPassword: "パスワード確認",
    loginTitle: "湘南国際株式会社\n旅行代理店専用予約システム",
    loginSubtitle: "アカウントにログインしてください",
    loginPanelTitle: "アカウントログイン",
    loginPanelSubtitle: "Sign In",
    loginSystem: "ログイン",
    authPlatformLine: "Professional Transportation Booking Platform",
    authTrustedTagline: "世界中の旅行会社様にご利用いただいています",
    authLogoCaption: "旅行代理店専用予約プラットフォーム",
    registerTitle: "湘南国際株式会社\n旅行代理店専用予約システム",
    registerSubtitle: "アカウントを作成",
    authFeatureSecure: "専用予約フローの保護",
    authFeatureLanguages: "中文 / 日本語 / English",
    authFeatureOperations: "旅行代理店と車両運行の管理",
    authFeatureQualityTitle: "高品質なサービスと清潔な車両",
    authFeatureQualityDesc: "経験豊富なドライバーと清潔に管理された車両で快適な移動を提供",
    authFeatureLanguagesTitle: "多言語サポート",
    authFeatureLanguagesDesc: "中国語・English・日本語に対応し、スムーズなコミュニケーションを実現",
    authFeatureBookingTitle: "便利な予約管理システム",
    authFeatureBookingDesc: "ご利用開始48時間前まで予約内容の変更が可能",
    systemTitle: "湘南国際株式会社旅行代理店専用予約システム",
    noAccount: "アカウントをお持ちでないですか？",
    hasAccount: "アカウントをお持ちですか？",
    registerNow: "今すぐ登録",
    loginNow: "今すぐログイン",
    loginFailed: "ログインに失敗しました。メールアドレスとパスワードを確認してください",
    registerSuccess: "登録成功！",
    registerSuccessMsg: "アカウントが送信されました。管理者の承認をお待ちください。承認後にログインできます。",
    redirecting: "ログインページにリダイレクト中...",
    
    // ユーザー情報
    customerCode: "顧客コード",
    customerName: "顧客名",
    companyName: "会社名/氏名",
    phone: "電話番号",
    phoneOptional: "電話番号（任意）",
    name: "名前",
    
    // 車両タイプ
    vehicleType: "車両タイプ",
    alpha: "アルファード",
    hiace: "ハイエース",
    luxuryHiace: "プレミアムハイエース",
    coaster: "コースター",
    bus: "バス",
    hiace14Seats: "14座ハイエース",
    
    // 注文関連
    myOrders: "予約履歴",
    createOrder: "新規予約",
    orderDetails: "予約詳細",
    orderSearchPlaceholder: "予約情報を検索",
    supplierCustomerCodeFilterPlaceholder: "顧客コードで絞り込み",
    supplierCustomerNameFilterPlaceholder: "顧客名で絞り込み",
    orderGroupAll: "全予約",
    orderGroupCompleted: "完了",
    orderGroupOngoing: "進行中",
    orderGroupNotStarted: "未開始",
    orderGroupToday: "今日",
    orderGroupTomorrow: "明日",
    orderNumber: "予約番号",
    supplierVehicleFilterAll: "全車種",
    supplierExportVisibleOrders: "表示中の予約を出力",
    supplierExportNoOrders: "出力できる予約がありません",
    supplierActionConfirm: "確認",
    supplierActionModify: "変更",
    supplierActionCancel: "キャンセル",
    supplierActionConfirmed: "確認済み",
    supplierActionUnavailable: "現在操作できません",
    supplierOpenChat: "チャットを開く",
    supplierChatUnavailable: "チャット未開放",
    supplierImportantException: "重要な確認事項",
    supplierNotesAndContact: "備考 / 特別要望 / 連絡先",
    supplierMissingField: "不足項目",
    supplierNoMatchingOrders: "条件に一致する予約がありません",
    supplierSelectAll: "全選択",
    supplierBulkCancel: "一括キャンセル",
    supplierShowingOrders: "予約を表示中",
    supplierSortNewest: "利用日が遅い順",
    supplierSortOldest: "利用日が早い順",
    supplierSortServiceDateDesc: "利用日が遅い順",
    supplierSortServiceDateAsc: "利用日が早い順",
    supplierServiceFilterAll: "全サービス",
    supplierServiceTransfer: "送迎",
    supplierServiceCharter: "貸切",
    supplierHideCompleted: "完了を非表示",
    supplierHideCancelled: "キャンセル済を非表示",
    supplierCopyOrder: "予約をコピー",
    supplierReturnOrder: "復路を作成",
    supplierTripSummary: "行程概要",
    supplierPriceReference: "料金は参考です",
    supplierPaymentPaid: "支払い済み",
    supplierExportFilename: "代理店予約",
    orderType: "予約タイプ",
    presetRoute: "定型ルート",
    customRoute: "カスタムルート",
    presetRouteDesc: "固定料金、すぐ予約",
    customRouteDesc: "見積もり待ち",
    
    // 新しい注文フロー
    departureLocation: "出発地",
    selectDeparture: "出発地を選択",
    tokyo: "東京",
    haneda: "羽田",
    narita: "成田",
    yokohama: "横浜",
    kanazawa: "金沢",
    other: "その他",
    
    serviceType: "サービスタイプ",
    selectServiceType: "サービスタイプを選択",
    transfer: "送迎/空港/駅",
    charter: "貸切",
    
    charterDuration: "貸切時間",
    selectCharterDuration: "貸切時間を選択",
    hours4: "4時間",
    hours6: "6時間",
    hours8: "8時間",
    hours10: "10時間",
    hours12: "12時間",
    
    // 追加サービス
    extraServices: "追加サービス",
    selectExtraServices: "必要な追加サービスを選択",
    airportSign: "空港お迎えボード",
    tokyoStationSign: "東京駅お迎えボード",
    odawaraStationSign: "小田原駅お迎えボード",
    hotelSign: "ホテルお迎えボード",
    shinkansenTicket: "新幹線チケット受取",
    otherService: "その他のサービス",
    otherServiceDesc: "その他のご要望を入力してください",
    otherServicePlaceholder: "必要なその他のサービスを説明してください...",
    needsApproval: "管理者承認が必要",
    
    // 注文情報
    pickupLocation: "乗車場所",
    destination: "目的地",
    departureDate: "出発日",
    pickupTime: "出発時刻",
    passengerCount: "乗客数",
    luggageCount: "荷物数",
    tripDetails: "詳細な行程",
    tripDetailsOptional: "詳細な行程（任意）",
    tripDetailsPlaceholder: "特別なご要望や詳細な行程があればこちらに記入してください...",
    
    // 価格
    price: "料金",
    totalPrice: "合計料金",
    waitingForQuote: "見積もり待ち",
    basePrice: "基本料金",
    extraServicePrice: "追加サービス料金",
    pendingQuote: "見積もり待ち",
    
    // 注文ステータス
    status: "ステータス",
    pending: "確認待ち",
    pendingConfirmation: "確認中",
    pendingQuoteStatus: "見積もり待ち",
    quoted: "見積もり済み",
    confirmed: "確認済み",
    completed: "完了",
    cancelled: "キャンセル",
    
    // 操作
    acceptQuote: "見積もりを承認",
    modifyOrder: "予約を変更",
    cancelOrder: "予約をキャンセル",
    canModify: "予約を変更できます",
    cannotModify: "出発時刻まで48時間以内のため、管理者にご連絡ください",
    confirmCancel: "この予約をキャンセルしてもよろしいですか？この操作は取り消せません。",
    cancelSuccess: "予約がキャンセルされました",
    updateSuccess: "予約が更新されました",
    editRoute: "ルートを編集",
    updateRoute: "ルートを更新",
    routeUpdateSuccess: "ルートが更新されました",
    
    // 管理者
    adminDashboard: "管理者ダッシュボード",
    userManagement: "ユーザー管理",
    routeManagement: "ルート管理",
    orderManagement: "予約管理",
    billingExport: "請求書エクスポート",
    pendingUsers: "承認待ちユーザー",
    allUsers: "全ユーザー",
    approve: "承認",
    reject: "拒否",
    approved: "承認済み",
    rejected: "拒否済み",
    
    // マイページ
    myPage: "マイページ",
    manageYourAccount: "アカウント情報を管理",
    accountInfo: "アカウント情報",
    editProfile: "プロフィール編集",
    changePassword: "パスワード変更",
    currentPassword: "現在のパスワード",
    newPassword: "新しいパスワード",
    confirmNewPassword: "新しいパスワード（確認）",
    saveChanges: "変更を保存",
    saving: "保存中...",
    profileUpdateSuccess: "プロフィールを更新しました",
    passwordChangeSuccess: "パスワードを変更しました",
    passwordMismatch: "新しいパスワードが一致しません",
    passwordTooShort: "パスワードは6文字以上必要です",
    emailCannotChange: "メールアドレスは変更できません",
    passwordMinLength: "6文字以上",
    
    // ルート管理
    addRoute: "ルート追加",
    routeName: "ルート名",
    routeType: "ルートタイプ",
    routeDescription: "ルート説明",
    priceAlpha: "アルファード料金",
    priceHiace: "ハイエース料金",
    priceLuxuryHiace: "プレミアムハイエース料金",
    
    // メッセージ
    createOrderSuccess: "予約が作成されました！",
    updateOrderSuccess: "予約が更新されました！",
    operationFailed: "操作に失敗しました",
    noOrders: "予約がありません",
    createFirstOrder: "最初の予約を作成",
    fillOrderInfo: "予約情報を入力してください",
    selectRoute: "ルートを選択",
    selectRoutePlaceholder: "-- ルートを選択してください --",
    noRoutesAvailable: "利用可能なルートがありません",
    deleteOrder: "予約を削除",
    confirmDelete: "この予約を削除してもよろしいですか？この操作は取り消せません。",
    deleteSuccess: "削除しました",
    orderNotStarted: "未開始",
    orderInProgress: "進行中",
    orderCompleted: "完了",
  },
  
  en: {
    // Common
    loading: "Loading...",
    submit: "Submit",
    cancel: "Cancel",
    confirm: "Confirm",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    logout: "Logout",
    welcome: "Welcome",
    
    // Language Selection
    language: "Language",
    selectLanguage: "Select Language",
    chinese: "中文",
    japanese: "日本語",
    english: "English",
    
    // Login/Register
    login: "Login",
    register: "Register",
    email: "Email Address",
    password: "Password",
    confirmPassword: "Confirm Password",
    loginTitle: "Shonan International Co., Ltd.\nTravel Agency Reservation System",
    loginSubtitle: "Please login to your account",
    loginPanelTitle: "Account Login",
    loginPanelSubtitle: "Sign In",
    loginSystem: "Login System",
    authPlatformLine: "Professional Transportation Booking Platform",
    authTrustedTagline: "Trusted by Travel Agencies Worldwide",
    authLogoCaption: "Travel Agency Booking Platform",
    registerTitle: "Shonan International Co., Ltd.\nTravel Agency Reservation System",
    registerSubtitle: "Create your account",
    authFeatureSecure: "Protected reservation workflow",
    authFeatureLanguages: "Chinese / Japanese / English",
    authFeatureOperations: "Travel agency and fleet operations",
    authFeatureQualityTitle: "Premium Service & Clean Vehicles",
    authFeatureQualityDesc: "Professional drivers and well-maintained vehicles for a comfortable journey",
    authFeatureLanguagesTitle: "Multilingual Support",
    authFeatureLanguagesDesc: "Available in Chinese, English and Japanese for seamless communication",
    authFeatureBookingTitle: "Easy Booking Management",
    authFeatureBookingDesc: "Modify your reservation online up to 48 hours before service begins",
    systemTitle: "Shonan International Co., Ltd. Travel Agency Exclusive Reservation Service",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    registerNow: "Register Now",
    loginNow: "Login Now",
    loginFailed: "Login failed, please check your email and password",
    registerSuccess: "Registration Successful!",
    registerSuccessMsg: "Your account has been submitted. Please wait for admin approval. You can login after approval.",
    redirecting: "Redirecting to login page...",
    
    // User Info
    customerCode: "Customer Code",
    customerName: "Customer Name",
    companyName: "Company/Name",
    phone: "Phone Number",
    phoneOptional: "Phone Number (Optional)",
    name: "Name",
    
    // Vehicle Types
    vehicleType: "Vehicle Type",
    alpha: "Alphard",
    hiace: "Hiace",
    luxuryHiace: "Premium Hiace",
    coaster: "Coaster",
    bus: "Bus",
    hiace14Seats: "14 seats Hiace",
    
    // Order Related
    myOrders: "My Bookings",
    createOrder: "New Booking",
    orderDetails: "Booking Details",
    orderSearchPlaceholder: "Search all order info",
    supplierCustomerCodeFilterPlaceholder: "Filter by customer code",
    supplierCustomerNameFilterPlaceholder: "Filter by customer name",
    orderGroupAll: "All Orders",
    orderGroupCompleted: "Completed",
    orderGroupOngoing: "In Progress",
    orderGroupNotStarted: "Not Started",
    orderGroupToday: "Today",
    orderGroupTomorrow: "Tomorrow",
    orderNumber: "Order No.",
    supplierVehicleFilterAll: "All Vehicles",
    supplierExportVisibleOrders: "Export Current Orders",
    supplierExportNoOrders: "No orders to export",
    supplierActionConfirm: "Confirm",
    supplierActionModify: "Modify",
    supplierActionCancel: "Cancel",
    supplierActionConfirmed: "Confirmed",
    supplierActionUnavailable: "Unavailable",
    supplierOpenChat: "Open Chat",
    supplierChatUnavailable: "Chat not enabled",
    supplierImportantException: "Important Exception",
    supplierNotesAndContact: "Notes / Requests / Contact",
    supplierMissingField: "Missing field",
    supplierNoMatchingOrders: "No orders match the filter",
    supplierSelectAll: "Select All",
    supplierBulkCancel: "Bulk Cancel",
    supplierShowingOrders: "Showing orders",
    supplierSortNewest: "Service Date: Latest First",
    supplierSortOldest: "Service Date: Earliest First",
    supplierSortServiceDateDesc: "Service Date: Latest First",
    supplierSortServiceDateAsc: "Service Date: Earliest First",
    supplierServiceFilterAll: "All Services",
    supplierServiceTransfer: "Transfer",
    supplierServiceCharter: "Charter",
    supplierHideCompleted: "Hide Completed",
    supplierHideCancelled: "Hide Cancelled",
    supplierCopyOrder: "Copy Order",
    supplierReturnOrder: "Create Return",
    supplierTripSummary: "Trip Summary",
    supplierPriceReference: "Price is for reference",
    supplierPaymentPaid: "Paid",
    supplierExportFilename: "supplier-orders",
    orderType: "Booking Type",
    presetRoute: "Preset Route",
    customRoute: "Custom Route",
    presetRouteDesc: "Fixed price, quick booking",
    customRouteDesc: "Awaiting quote",
    
    // New Order Flow
    departureLocation: "Departure Location",
    selectDeparture: "Select Departure",
    tokyo: "Tokyo",
    haneda: "Haneda",
    narita: "Narita",
    yokohama: "Yokohama",
    kanazawa: "Kanazawa",
    other: "Other",
    
    serviceType: "Service Type",
    selectServiceType: "Select Service Type",
    transfer: "Transfer/Airport/Station Pickup",
    charter: "Charter",
    
    charterDuration: "Charter Duration",
    selectCharterDuration: "Select Charter Duration",
    hours4: "4 Hours",
    hours6: "6 Hours",
    hours8: "8 Hours",
    hours10: "10 Hours",
    hours12: "12 Hours",
    
    // Extra Services
    extraServices: "Extra Services",
    selectExtraServices: "Select needed extra services",
    airportSign: "Airport Sign Board",
    tokyoStationSign: "Tokyo Station Sign Board",
    odawaraStationSign: "Odawara Station Sign Board",
    hotelSign: "Hotel Sign Board",
    shinkansenTicket: "Shinkansen Ticket Pickup",
    otherService: "Other Services",
    otherServiceDesc: "Please describe your other needs",
    otherServicePlaceholder: "Describe the other services you need...",
    needsApproval: "Requires admin approval",
    
    // Order Information
    pickupLocation: "Pickup Location",
    destination: "Destination",
    departureDate: "Departure Date",
    pickupTime: "Pickup Time",
    passengerCount: "Passenger Count",
    luggageCount: "Luggage Count",
    tripDetails: "Trip Details",
    tripDetailsOptional: "Trip Details (Optional)",
    tripDetailsPlaceholder: "If you have special requirements or detailed itinerary, please note here...",
    
    // Pricing
    price: "Price",
    totalPrice: "Total Price",
    waitingForQuote: "Awaiting Quote",
    basePrice: "Base Price",
    extraServicePrice: "Extra Service Fee",
    pendingQuote: "Pending Quote",
    
    // Order Status
    status: "Status",
    pending: "Pending",
    pendingConfirmation: "Pending Confirmation",
    pendingQuoteStatus: "Pending Quote",
    quoted: "Quoted",
    confirmed: "Confirmed",
    completed: "Completed",
    cancelled: "Cancelled",
    
    // Actions
    acceptQuote: "Accept Quote",
    modifyOrder: "Modify Booking",
    cancelOrder: "Cancel Booking",
    canModify: "You can modify this booking",
    cannotModify: "Within 48 hours of departure, please contact admin to modify",
    confirmCancel: "Are you sure you want to cancel this booking? This action cannot be undone.",
    cancelSuccess: "Booking cancelled successfully",
    updateSuccess: "Booking updated successfully",
    editRoute: "Edit Route",
    updateRoute: "Update Route",
    routeUpdateSuccess: "Route updated successfully",
    
    // Admin
    adminDashboard: "Admin Dashboard",
    userManagement: "User Management",
    routeManagement: "Route Management",
    orderManagement: "Booking Management",
    billingExport: "Billing Export",
    pendingUsers: "Pending Users",
    allUsers: "All Users",
    approve: "Approve",
    reject: "Reject",
    approved: "Approved",
    rejected: "Rejected",
    
    // My Page
    myPage: "My Page",
    manageYourAccount: "Manage your account",
    accountInfo: "Account Information",
    editProfile: "Edit Profile",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    saveChanges: "Save Changes",
    saving: "Saving...",
    profileUpdateSuccess: "Profile updated successfully",
    passwordChangeSuccess: "Password changed successfully",
    passwordMismatch: "New passwords do not match",
    passwordTooShort: "Password must be at least 6 characters",
    emailCannotChange: "Email address cannot be changed",
    passwordMinLength: "At least 6 characters",
    
    // Route Management
    addRoute: "Add Route",
    routeName: "Route Name",
    routeType: "Route Type",
    routeDescription: "Route Description",
    priceAlpha: "Alphard Price",
    priceHiace: "Hiace Price",
    priceLuxuryHiace: "Premium Hiace Price",
    
    // Messages
    createOrderSuccess: "Booking created successfully!",
    updateOrderSuccess: "Booking updated successfully!",
    operationFailed: "Operation failed",
    noOrders: "No bookings",
    createFirstOrder: "Create your first booking",
    fillOrderInfo: "Please fill in the booking information",
    selectRoute: "Select Route",
    selectRoutePlaceholder: "-- Please select a route --",
    noRoutesAvailable: "No routes available",
    deleteOrder: "Delete Booking",
    confirmDelete: "Are you sure you want to delete this booking? This action cannot be undone.",
    deleteSuccess: "Deleted successfully",
    orderNotStarted: "Not Started",
    orderInProgress: "In Progress",
    orderCompleted: "Completed",
  }
};

translations.es = {
  ...translations.en,
  language: "Idioma",
  selectLanguage: "Seleccionar idioma",
  chinese: "中文",
  japanese: "日本語",
  english: "English",
  spanish: "Español",
  login: "Iniciar sesión",
  register: "Registrarse",
  email: "Correo electrónico",
  password: "Contraseña",
  confirmPassword: "Confirmar contraseña",
  loginTitle: "Shonan International Co., Ltd.\nSistema de reservas para agencias de viaje",
  loginSubtitle: "Inicie sesión en su cuenta",
  loginPanelTitle: "Acceso a la cuenta",
  loginPanelSubtitle: "Iniciar sesión",
  loginSystem: "Entrar al sistema",
  authTrustedTagline: "Servicio para agencias de viaje internacionales",
  authLogoCaption: "Plataforma de reservas para agencias",
  registerTitle: "Shonan International Co., Ltd.\nSistema de reservas para agencias de viaje",
  registerSubtitle: "Crear una cuenta",
  authFeatureSecure: "Flujo de reservas protegido",
  authFeatureLanguages: "Chino / Japonés / Inglés / Español",
  authFeatureOperations: "Operación para agencias y flotas",
  authFeatureQualityTitle: "Servicio premium y vehículos limpios",
  authFeatureQualityDesc: "Conductores profesionales y vehículos bien mantenidos para un viaje cómodo",
  authFeatureLanguagesTitle: "Soporte multilingüe",
  authFeatureLanguagesDesc: "Disponible en chino, japonés, inglés y español",
  authFeatureBookingTitle: "Gestión sencilla de reservas",
  authFeatureBookingDesc: "Modifique su reserva en línea hasta 48 horas antes del servicio",
  systemTitle: "Servicio exclusivo de reservas para agencias de viaje de Shonan International",
  noAccount: "¿No tiene una cuenta?",
  hasAccount: "¿Ya tiene una cuenta?",
  registerNow: "Registrarse ahora",
  loginNow: "Iniciar sesión ahora",
  loginFailed: "Error de inicio de sesión. Revise su correo y contraseña",
  registerSuccess: "Registro completado",
  registerSuccessMsg: "Su cuenta fue enviada. Espere la aprobación del administrador.",
  redirecting: "Redirigiendo al inicio de sesión...",
  customerCode: "Código de cliente",
  customerName: "Nombre del cliente",
  companyName: "Empresa / Nombre",
  phone: "Teléfono",
  phoneOptional: "Teléfono (opcional)",
  name: "Nombre",
  vehicleType: "Tipo de vehículo",
  alpha: "Alphard",
  hiace: "Hiace",
  luxuryHiace: "Hiace premium",
  coaster: "Coaster",
  bus: "Autobús",
  hiace14Seats: "Hiace de 14 asientos",
  myOrders: "Mis reservas",
  createOrder: "Nueva reserva",
  orderDetails: "Detalle de la reserva",
  orderSearchPlaceholder: "Buscar en toda la información de la reserva",
  supplierCustomerCodeFilterPlaceholder: "Filtrar por código de cliente",
  supplierCustomerNameFilterPlaceholder: "Filtrar por nombre de cliente",
  orderGroupAll: "Todas",
  orderGroupCompleted: "Completadas",
  orderGroupOngoing: "En curso",
  orderGroupNotStarted: "No iniciadas",
  orderGroupToday: "Hoy",
  orderGroupTomorrow: "Mañana",
  orderNumber: "N.º de reserva",
  supplierVehicleFilterAll: "Todos los vehículos",
  supplierExportVisibleOrders: "Exportar reservas visibles",
  supplierExportNoOrders: "No hay reservas para exportar",
  supplierActionConfirm: "Confirmar",
  supplierActionModify: "Modificar",
  supplierActionCancel: "Cancelar",
  supplierActionConfirmed: "Confirmada",
  supplierActionUnavailable: "No disponible",
  supplierOpenChat: "Abrir chat",
  supplierChatUnavailable: "Chat no habilitado",
  supplierImportantException: "Incidencia importante",
  supplierNotesAndContact: "Notas / Solicitudes / Contacto",
  supplierMissingField: "Campo faltante",
  supplierNoMatchingOrders: "No hay reservas que coincidan",
  supplierSelectAll: "Seleccionar todo",
  supplierBulkCancel: "Cancelar en lote",
  supplierShowingOrders: "Mostrando reservas",
  supplierSortNewest: "Fecha de servicio: más reciente primero",
  supplierSortOldest: "Fecha de servicio: más antigua primero",
  supplierSortServiceDateDesc: "Fecha de servicio: más reciente primero",
  supplierSortServiceDateAsc: "Fecha de servicio: más antigua primero",
  supplierServiceFilterAll: "Todos los servicios",
  supplierServiceTransfer: "Traslado",
  supplierServiceCharter: "Charter",
  supplierHideCompleted: "Ocultar completadas",
  supplierHideCancelled: "Ocultar canceladas",
  supplierCopyOrder: "Copiar reserva",
  supplierReturnOrder: "Crear regreso",
  supplierTripSummary: "Resumen del viaje",
  supplierPriceReference: "Precio de referencia",
  supplierPaymentPaid: "Pagado",
  supplierExportFilename: "reservas-agencia",
  orderType: "Tipo de reserva",
  presetRoute: "Ruta predefinida",
  customRoute: "Ruta personalizada",
  presetRouteDesc: "Precio fijo, reserva rápida",
  customRouteDesc: "Pendiente de cotización",
  departureLocation: "Lugar de salida",
  selectDeparture: "Seleccione salida",
  serviceType: "Tipo de servicio",
  selectServiceType: "Seleccione tipo de servicio",
  transfer: "Traslado / Aeropuerto / Estación",
  charter: "Charter",
  charterDuration: "Duración del charter",
  selectCharterDuration: "Seleccione duración",
  extraServices: "Servicios adicionales",
  selectExtraServices: "Seleccione servicios adicionales",
  pickupLocation: "Lugar de recogida",
  destination: "Destino",
  departureDate: "Fecha de salida",
  pickupTime: "Hora de recogida",
  passengerCount: "Pasajeros",
  luggageCount: "Equipaje",
  tripDetails: "Detalles del viaje",
  tripDetailsOptional: "Detalles del viaje (opcional)",
  tripDetailsPlaceholder: "Indique requisitos especiales o itinerario detallado...",
  price: "Precio",
  totalPrice: "Precio total",
  waitingForQuote: "Pendiente de cotización",
  pendingQuote: "Cotización pendiente",
  status: "Estado",
  pending: "Pendiente",
  pendingConfirmation: "Pendiente de confirmación",
  pendingQuoteStatus: "Cotización pendiente",
  quoted: "Cotizado",
  confirmed: "Confirmado",
  completed: "Completado",
  cancelled: "Cancelado",
  acceptQuote: "Aceptar cotización",
  modifyOrder: "Modificar reserva",
  cancelOrder: "Cancelar reserva",
  canModify: "Puede modificar esta reserva",
  cannotModify: "Dentro de las 48 horas previas, contacte al administrador",
  confirmCancel: "¿Seguro que desea cancelar esta reserva?",
  cancelSuccess: "Reserva cancelada correctamente",
  updateSuccess: "Reserva actualizada correctamente",
  createOrderSuccess: "Reserva creada correctamente",
  updateOrderSuccess: "Reserva actualizada correctamente",
  operationFailed: "Operación fallida",
  noOrders: "No hay reservas",
  createFirstOrder: "Crear primera reserva",
  fillOrderInfo: "Complete la información de la reserva",
  selectRoute: "Seleccionar ruta",
  selectRoutePlaceholder: "-- Seleccione una ruta --",
  noRoutesAvailable: "No hay rutas disponibles",
  deleteOrder: "Eliminar reserva",
  confirmDelete: "¿Seguro que desea eliminar esta reserva?",
  deleteSuccess: "Eliminado correctamente",
  orderNotStarted: "No iniciado",
  orderInProgress: "En curso",
  orderCompleted: "Completado",
  myPage: "Mi página",
  manageYourAccount: "Gestionar cuenta",
  accountInfo: "Información de la cuenta",
  editProfile: "Editar perfil",
  changePassword: "Cambiar contraseña",
  saveChanges: "Guardar cambios",
  saving: "Guardando...",
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['zh'][key] || key;
};

export const getVehicleTypeName = (lang, type) => {
  const vehicleNames = {
    alphard: {
      zh: "阿尔法",
      ja: "アルファード",
      en: "Alphard",
      es: "Alphard"
    },
    hiace: {
      zh: "海狮",
      ja: "ハイエース",
      en: "Hiace",
      es: "Hiace"
    },
    premium_hiace: {
      zh: "豪华海狮",
      ja: "プレミアムハイエース",
      en: "Premium Hiace",
      es: "Hiace premium"
    },
    coaster: {
      zh: "考斯特",
      ja: "コースター",
      en: "Coaster",
      es: "Coaster"
    },
    bus: {
      zh: "巴士",
      ja: "バス",
      en: "Bus",
      es: "Autobús"
    },
    hiace_14_seats: {
      zh: "14座海狮",
      ja: "14座ハイエース",
      en: "14 seats Hiace",
      es: "Hiace de 14 asientos"
    }
  };
  
  // 兼容旧车型名称
  const normalizedType = type === 'alpha' ? 'alphard' : (type === 'luxury_hiace' ? 'premium_hiace' : type);
  
  return vehicleNames[normalizedType]?.[lang] || type;
};
